import axios from 'axios'

const server = process.env.REACT_APP_SERVER_URL

export const createAssociatedCode = async (
  associatedCode: ICreateAssociatedCodeDTO
): Promise<IAssociateCode> => {
  try {
    const response = await axios.post<ICreateAssociatedCodeResponseDTO>(
      `${server}/inventory/code/associated`,
      {
        code: associatedCode,
      }
    )
    const newAssociatedCode = {
      id: response.data.newAssociatedCode.id,
      code: associatedCode.code,
      item: {
        id: associatedCode.item.id,
      },
    }
    return newAssociatedCode
  } catch (error) {
    throw error
  }
}

export const deleteAssociatedCode = async (
  associatedCodeId: string,
  itemId: string
): Promise<any> => {
  try {
    await axios.delete<any>(
      `${server}/inventory/code?id=${associatedCodeId}`
    )
  } catch (error) {
    throw error
  }
}

interface ICreateAssociatedCodeDTO {
  code: string
  item: {
    id: string
  }
}

interface ICreateAssociatedCodeResponseDTO {
  status: number
  newAssociatedCode: {
    id: string
  }
  message: string
}

interface IDeleteAssociatedCodeResponseDTO {
  status: number
  deletedAssociatedCode: {
    id: string
  }
  message: string
}

interface IDeletedAssociatedCode {
  id: string
  itemId: string
}

export interface IAssociateCode {
  id: string
  code: string
  item: { 
    id: string 
  }
}
